import { z } from "zod";
import { Form } from "@/app/global-components/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import ConfirmFormFieldView from "./confirm-form-field-view";
import ConfirmSubmitView from "./confirm-submit-view";
import useConfirm from "@/hooks/use-confirm"; // Import the new hook
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ConfirmSchema } from "@/schema";
import { useState } from "react";
import VerifiedEmail from "./verified-email";
import { toast } from "react-toastify";

const ConfirmFormView = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [confirmed, setConfirmed] = useState(false);

  const { confirm, isLoading, error } = useConfirm();
  const form = useForm<z.infer<typeof ConfirmSchema>>({
    resolver: zodResolver(ConfirmSchema),
  });
  const { resendCode, isLoading: istokenLoading } = useConfirm();
  const email = form.watch("email");
  const handleResendCode = async () => {
    if (email) {
      try {
        await resendCode(email ?? "");
      } catch (err) {}
    } else {
      toast.error(t("alerts.error.resendCodeEmailError"));
    }
  };
  const onSubmit = async (data: z.infer<typeof ConfirmSchema>) => {
    try {
      const response = await confirm({ email: data.email, code: data.code });
      if (response) {
        setConfirmed(true);
      }
    } catch (err) {
      setConfirmed(false);
      console.log(err);
    }
  };
  if (!confirmed) {
    return (
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <p className="text-xs text-end text-textcolor-mediumGray">
            <span
              className="underline text-textcolor-black cursor-pointer"
              onClick={handleResendCode}
              style={{ pointerEvents: isLoading ? "none" : "auto" }}
            >
              {istokenLoading ? t("status.sending") : t("actions.resendCode")}
            </span>
          </p>
          <ConfirmFormFieldView
            name="email"
            label={t("authentication.fields.email")}
            placeholder={t("profile.placeholders.enterEmail")}
            inputType="text"
            formControl={form.control}
          />
          <ConfirmFormFieldView
            name="code"
            label={t("authentication.fields.token")}
            placeholder={t("authentication.placeholders.enterToken")}
            inputType="text"
            formControl={form.control}
          />
          <ConfirmSubmitView isLoading={isLoading} />
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        </form>
      </Form>
    );
  } else {
    return <VerifiedEmail />;
  }
};

export default ConfirmFormView;
